import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';

/**
 * Special model used only client-side to hold a free text search value in the search field
 */
export default class Text extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "text", Model.attribute('text'));
  }
}
flarum.reg.add('fof-user-directory', 'forum/models/Text', Text);